import React, {Fragment, useMemo} from 'react';
import {NavLink, LinkProps as NavLinkProps, useLocation} from 'react-router-dom';

import {useMenuList} from 'presentation/components';
import Icon from 'presentation/icons';

import {translations} from 'presentation/translations-new';
import {MenuListType} from '../types';
import {StyledBottomNavigation, NavigationItem, StyledPaper} from './styles';
import {useNetworkProviderItems} from 'presentation/pages/private/home/components/OptionsDrawer/hooks/useNetworkProviderItems';
import {useOpenOptionsDrawerStore} from 'presentation/pages/private/store/useOpenOptionsDrawer';

const {network} = translations['pt-br'].others.sidebar;
const {serviceNetwork} = translations['pt-br'].privateFlow.services;

const Link = React.forwardRef<HTMLAnchorElement, NavLinkProps>((itemProps, ref) => (
	<NavLink ref={ref} {...itemProps} />
));

const ModalLink = React.forwardRef<HTMLDivElement>((itemProps, ref) => (
	<div ref={ref} {...itemProps} />
));

export function NotredameBottomNav() {
	const {MENU_LIST} = useMenuList();
	const {pathname} = useLocation();

	const {openOptionsDrawer} = useOpenOptionsDrawerStore();
	const {items: networkProviderItems} = useNetworkProviderItems();

	const activeIndex = useMemo(() => {
		const bestMatch = MENU_LIST.filter(
			item => pathname === item.route || pathname.startsWith(`${item.route}/`),
		).reduce<MenuListType | null>((best, current) => {
			const currentRouteLength = current.route?.length ?? 0;
			const bestRouteLength = best?.route?.length ?? 0;

			return !best || currentRouteLength > bestRouteLength ? current : best;
		}, null);
		return bestMatch ? MENU_LIST.findIndex(item => item.route === bestMatch.route) : -1;
	}, [pathname, MENU_LIST]);

	function handleModalActionLink(item: MenuListType) {
		if (item.title === network) {
			openOptionsDrawer(serviceNetwork, networkProviderItems);
		}
	}

	return (
		<Fragment>
			<StyledPaper>
				<StyledBottomNavigation showLabels value={activeIndex}>
					{MENU_LIST.map((item: MenuListType, index: number) => {
						const isFunctionAction: boolean = item?.title === network;
						return (
							<NavigationItem
								title={item.title}
								key={index}
								label={item.title}
								component={isFunctionAction ? ModalLink : Link}
								to={isFunctionAction ? undefined : item.route}
								icon={<Icon size={16} name={item.icon} />}
								onClick={
									isFunctionAction
										? (): void => handleModalActionLink(item)
										: undefined
								}
								id={item?.id}
							/>
						);
					})}
				</StyledBottomNavigation>
			</StyledPaper>
		</Fragment>
	);
}
